'use client'; // Error components must be Client Components

import ErrorComponent from '@/components/layout/ErrorComponent';
import '../../styles/global.scss';
export default function Error() {
    return <ErrorComponent />;
}
